export default "__VITE_ASSET__DL9eF_9___"